import {
    QueryClient,
    UseMutationResult,
    UseQueryResult,
    useMutation,
    useQuery,
    useQueryClient
} from '@tanstack/react-query';
import EmailPreferencesService from 'src/services/email-preferences.service';
import { EmailPreferencesModel, MaskedAccountInfoModel } from 'src/types/email-preferences.model';

const emailPreferencesQueryKey: string = 'email-preferences';
const maskedAccountInfoQueryKey: string = 'masked-account-info';

export const useEmailPreferences = (): UseQueryResult<EmailPreferencesModel> => {
    return useQuery<EmailPreferencesModel>({
        queryKey: [emailPreferencesQueryKey],
        queryFn: async () => await EmailPreferencesService.getEmailPreferences()
    });
};

export const useUpdateEmailPreferences = (): UseMutationResult<any, unknown, EmailPreferencesModel> => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (emailPreferences: EmailPreferencesModel) =>
            await EmailPreferencesService.updateEmailPreferences(emailPreferences),
        onSuccess: async () => {
            await invalidateEmailPreferences(queryClient);
        }
    });
};

export const useMaskedAccountInfo = (): UseQueryResult<MaskedAccountInfoModel> => {
    return useQuery<MaskedAccountInfoModel>({
        queryKey: [maskedAccountInfoQueryKey],
        queryFn: async () => await EmailPreferencesService.getMaskedAccountInfo()
    });
};

export const invalidateEmailPreferences = async (queryClient: QueryClient): Promise<void> => {
    await queryClient.invalidateQueries([emailPreferencesQueryKey]);
};

export const invalidateMaskedAccountInfo = async (queryClient: QueryClient): Promise<void> => {
    await queryClient.invalidateQueries([maskedAccountInfoQueryKey]);
};
